export enum OrganizationType {
  Default = 'Default'
}

